import React from 'react';
import { Image } from '@fiverr-private/media';
import { I18n } from '@fiverr-private/i18n-react';
import { Typography } from '@fiverr-private/typography';

interface FiverrAdLblProps {
    isPromoted: boolean;
    faUrl: string;
}
export const FiverrAdRightLbl = ({ isPromoted, faUrl }: FiverrAdLblProps) => {
    const fallback = isPromoted ? (
        <Typography as="span" className={'text-normal'} lineHeight="b_sm">
            &nbsp;
            <I18n k="gig_cards.badges.promoted_gigs.seller_name_suffix.ad_by" />
        </Typography>
    ) : (
        <></>
    );
    return faUrl ? (
        <Image alt="" src={faUrl} width="auto" maxHeight="22px" flexShrink={0} marginLeft="1" marginTop="px" />
    ) : (
        fallback
    );
};
